module.exports = "<svg id=\"Options\" xmlns=\"http://www.w3.org/2000/svg\" width=\"4\" height=\"20\" viewBox=\"0 0 4 20\">\n  <path id=\"Unión_1\" data-name=\"Unión 1\" d=\"M0,18a2,2,0,1,1,2,2A2,2,0,0,1,0,18Zm0-8a2,2,0,1,1,2,2A2,2,0,0,1,0,10ZM0,2A2,2,0,1,1,2,4,2,2,0,0,1,0,2Z\" fill=\"#242424\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/icons/options.svg
// module id = 1278
// module chunks = 0